import { render, staticRenderFns } from "./TableMyDocuments.vue?vue&type=template&id=58f9f1b7&"
import script from "./TableMyDocuments.vue?vue&type=script&lang=ts&"
export * from "./TableMyDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports